import apiClient from './apiClient';

export const profileApi = {
  getAdminProfile: async (id) => {
    const response = await apiClient.get(`/auth/admin/profile/${id}`);
    return response.data;
  },
  
  editProfile: async (profileData) => {
    const formData = new FormData();
    
    // Add text fields
    if (profileData.userId) formData.append('userId', profileData.userId);
    if (profileData.firstName) formData.append('firstName', profileData.firstName);
    if (profileData.lastName !== undefined) formData.append('lastName', profileData.lastName);
    
    // Add logo file if present
    if (profileData.logo && profileData.logo instanceof File) {
      formData.append('logo', profileData.logo);
    }
    
    const response = await apiClient.patch('/auth/admin/profile', formData);
    return response.data;
  },

  updateLogo: async (logoData) => {
    const formData = new FormData();
    
    // Convert base64 back to file
    const base64Data = logoData.logo.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const file = new File([byteArray], logoData.fileName, { type: logoData.fileType });
    
    formData.append('logo', file);
    formData.append('userId', logoData.userId);
    
    const response = await apiClient.patch('/auth/admin/logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  resetPassword: async (resetData) => {
    const response = await apiClient.post('/auth/admin/change-password', resetData);
    return response.data;
  },

  verifyMail: async (mailData) => {
    const response = await apiClient.post('/auth/admin/verify-mail', mailData);
    return response.data;
  }
};